import { render } from "./GlLoaderLazy.vue?vue&type=template&id=358f18dc&scoped=true"
import script from "./GlLoaderLazy.vue?vue&type=script&lang=js"
export * from "./GlLoaderLazy.vue?vue&type=script&lang=js"

import "./GlLoaderLazy.vue?vue&type=style&index=0&id=358f18dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-358f18dc"

export default script